module.exports = __webpack_public_path__ + "static/media/67-iveco.93d25588.jpg";